import React from 'react';
import {
    Box,
    Typography,
    Button
} from '@mui/material';
import {
    DataGrid
} from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { useCompanyPrices, useBotmarkPrices, useUpdatePrice, useDeletePrice } from '../../../hooks/usePrices';

function PriceOptionsDatagrid(){
    const updatePrice = useUpdatePrice();
    const deletePriceMutation = useDeletePrice();
    const [open, setOpen] = React.useState(false);
    const [check, setCheck] = React.useState(false);
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies);
    const userData = useSelector((state) => state.UserReducer.user);
    const companyId = userCompany[0]?.id;
    const { data: CompanyPrices = [] } = useCompanyPrices({
        companyId,
        enabled: Boolean(companyId),
    });
    const { data: BotmarkPrimaryPrices = [] } = useBotmarkPrices({
        enabled: Boolean(userData?.isAdmin),
    });

    const [editRowsModel, setEditRowsModel] = React.useState({});
    const handleEditRowsModelChange = React.useCallback((model) => {
        setEditRowsModel(model);
    }, []);

    ///allows for editing the datagrid
    const handleSave = () => {
        const objId = Object.keys(editRowsModel)[0];
        const obj = Object.values(editRowsModel)[0];
        const item = {
            id: objId,
            ItemName: obj.itemName.value,
            Description: obj.description.value,
            Rate: obj.rate.value,
            Unit: obj.unit.value,
            CompanyId: userCompany[0].id
        };
        updatePrice.mutate(item);
    };

    let allPrices = [];
    let columns = [];
    if (userData.isAdmin){
        allPrices = [...CompanyPrices, ...BotmarkPrimaryPrices];
    } else {
        allPrices = [...CompanyPrices];
    }

    /// allows for different data display for super adins and normal users
    if (userData.isAdmin == true){
        columns = [
            { field: 'itemName', headerName: 'Item', width: 200, headerClassName: 'header', editable: true },
            { field: 'description', headerName: 'Description', width: 300, headerClassName: 'header', editable: true },
            { field: 'unit', headerName: 'Unit', width: 100, headerClassName: 'header', editable: true },
            { field: 'rate', headerName: 'Rate', width: 100, headerClassName: 'header', editable: true },
            { field: 'isForTaxes', headerName: 'Is Tax', width: 100, headerClassName: 'header', renderCell: (params) => (
                isForTaxes(params.row)
            )},
            { field: 'isBotmarkPrimary', headerName: 'Botmark Fee', width: 100, headerClassName: 'header', renderCell: (params) => (
                isBotmarkPrimary(params.row)
            )},
            { field: 'Remove', width: 100, headerClassName: 'header', sortable: false,
                renderCell: (cellValues)=> {
                    return(
                        <Button color="error" onClick={() => deletePrice(cellValues)}>Delete</Button>
                    )
                }
            },
        ];
    } else {
        columns = [
            { field: 'itemName', headerName: 'Item', width: 200, headerClassName: 'header', editable: true },
            { field: 'description', headerName: 'Description', width: 300, headerClassName: 'header', editable: true },
            { field: 'unit', headerName: 'Unit', width: 100, headerClassName: 'header', editable: true },
            { field: 'rate', headerName: 'Rate', width: 100, headerClassName: 'header', editable: true },
            { field: 'isForTaxes', headerName: 'Is Tax', width: 100, headerClassName: 'header', renderCell: (params) => (
                isForTaxes(params.row)
            )},
            { field: 'Remove', width: 100, headerClassName: 'header', sortable: false,
                renderCell: (cellValues)=> {
                    return(
                        <Button color="error" onClick={() => deletePrice(cellValues)}>Delete</Button>
                    )
                }
            },
        ];
    }

    function isBotmarkPrimary(x) {
        if ( x.isBotmarkPrimary === true ) {
            return (
                <Button variant="contained" color="success">
                    True
                </Button>
            )
        }
        if (x.isBotmarkPrimary === false) {
            return(
                <Button variant="contained" color="secondary">
                    False
                </Button>
            )
        }
    };

    function isForTaxes(x) {
        if ( x.isForTaxes === true ) {
            return (
                <Button variant="contained" color="primary">
                    True
                </Button>
            )
        }
        if (x.isForTaxes === false) {
            return(
                <Button variant="contained" color="secondary">
                    False
                </Button>
            )
        }
    };

    ///delete price option
    function deletePrice(cellValues){
        deletePriceMutation.mutate({id:cellValues.row.id, CompanyId: userCompany[0].id});
    }

    const handleOpen = () => setOpen(!open);
    const handleCheck = () => setCheck(!check);

    return (
        <div>
            <Box p={3} sx={{ '& .header': { backgroundColor: '#e2e2e2' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='h3' textAlign='left' p={2}>
                        Price Options
                    </Typography>
                </Box>
                <Box textAlign={"left"}>
                    <Typography textAlign={"left"} color={"blue"} variant='h4'>
                        Editing Mode
                    </Typography>
                    <Typography textAlign={"left"} variant='body2'>
                        Double click to enter row, hit enter or click out to save changes. <br/> Press Esc to cancel editing a field.
                    </Typography>
                </Box>
                <DataGrid
                    editMode="row"
                    onRowEditCommit={handleSave}
                    editRowsModel={editRowsModel}
                    onEditRowsModelChange={handleEditRowsModelChange}
                    columns={columns}
                    rows={allPrices}
                    style={{textAlign:'left', height:'70vh'}}
                />
            </Box>
        </div>
    )
};

export default PriceOptionsDatagrid;